module.exports = __webpack_public_path__ + "static/bookofmine-f7fe39535c78b06b5ffde7954f385a80.png";